import * as yup from 'yup';

interface TestDriveBookingSchemaProps {
  firstName: {
    format: string;
    required: string;
    minLength: string;
    maxLength: string;
  };
  lastName: {
    format: string;
    required: string;
    minLength: string;
    maxLength: string;
  };
  email: {
    format: string;
    required: string;
  };
  requestTimeSlot: {
    required: string;
  };
  phone: {
    minLength: string;
    maxLength: string;
  };
}
const testDriveBookingSchema = (
  validationMsgs: TestDriveBookingSchemaProps
) => {
  const { lastName, firstName, email, requestTimeSlot, phone } = validationMsgs;

  return yup.object({
    lastName: yup
      .string()
      .trim()
      .matches(/^[a-zA-Z\-äöüÄÖÜß\s]*$/, lastName.format)
      .required(lastName.required)
      .min(2, lastName.minLength)
      .max(100, lastName.maxLength),
    firstName: yup
      .string()
      .trim()
      .matches(/^[a-zA-Z\-äöüÄÖÜß\s]*$/, firstName.format)
      .required(firstName.required)
      .min(2, firstName.minLength)
      .max(100, firstName.maxLength),
    email: yup.string().email(email.format).required(email.required),
    requestTimeSlot: yup.object().shape({
      requestDate: yup.string().required(requestTimeSlot.required).nullable(),
      requestTime: yup.string().required(requestTimeSlot.required),
    }),
    phone: yup.string().min(4, phone.minLength).max(20, phone.maxLength),
    requestTimeSlotOptional: yup.object().shape({
      requestDate: yup.string().nullable(),
      requestTime: yup.string().nullable(),
    }),
  });
};
export default testDriveBookingSchema;
